import { render, staticRenderFns } from "./LgFormInputMask.vue?vue&type=template&id=d18dea8e&scoped=true"
import script from "./LgFormInputMask.vue?vue&type=script&lang=js"
export * from "./LgFormInputMask.vue?vue&type=script&lang=js"
import style0 from "./LgFormInputMask.vue?vue&type=style&index=0&id=d18dea8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18dea8e",
  null
  
)

export default component.exports